"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Column = React.forwardRef((_a, ref) => {
    var { className } = _a, rest = tslib_1.__rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({}, rest, { item: true, className: className, ref: ref }));
});
exports.default = Column;
